import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, PRIMARY_OUTLET, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { map } from 'rxjs/internal/operators';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.css']
})
export class BreadcrumbComponent implements OnInit {

  public breadcrumbs: any = [];
  public currentPageTitle: string = "";

  constructor(private activatedRoute: ActivatedRoute, private router: Router) {

    this.breadcrumbs.push({
      "title": 'Home',
      "route": '/home'
    });

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .pipe(map(() => this.activatedRoute))
      .pipe(map((route) => {
        while (route.firstChild) { route = route.firstChild; }
        return route;
      }))
      .pipe(filter(route => route.outlet === PRIMARY_OUTLET))
      .subscribe(route => {

        let snapshot = this.router.routerState.snapshot;
        // let title = route.snapshot.data['title'];
        // let parent = route.parent?.snapshot.data['page'];
        // let child = route.snapshot.data['page'];

        // this.breadcrumbs = [];
        this.currentPageTitle = route.snapshot.data['title'];
        // let url = snapshot.url;

        this.breadcrumbs.push({
          "title": route.snapshot.data['title'],
          "route": snapshot.url
        });
      });
  }

  ngOnInit(): void {
  }
  goback(){
    this.router.navigate(['/help-section']);
  }
}
